/* global $ */
var Proj = (function(proj) {
    'use strict';

    var opt = {
        selector: '.js-shipment',
        itemSelector: '.js-shipment__item',
        shipmentMapSelector: '.js-shipment__map'
    };

    function initShipment() {
        var $block = $(opt.selector),
            $items = $block.find(opt.itemSelector),
            $shipment = $(opt.shipmentMapSelector);

        var totalCoords = [];

        if ($items.length) {
            for (var i = 0; i < $items.length; i++) {
                var $item = $items.eq(i),
                    itemCoords = $item.data('coords');

                if (itemCoords !== '') {
                    var coords = itemCoords.split(/\s*;\s*/);
                    for (var j = 0; j < coords.length; j++) {
                        totalCoords.push(coords[j].split(/\s*,\s*/));
                    }
                }
            }
            ymaps.ready(function() {
                var shipmentMap = new ymaps.Map($shipment.get(0), {
                    zoom: 11,
                    center: totalCoords[0],
                    controls: ['default']
                });
                var shipmentCollection = new ymaps.GeoObjectCollection({}, { preset: 'islands#darkOrangeIcon' });
                for (var i = 0; i < totalCoords.length; i++) {
                    var placemark = new ymaps.Placemark(totalCoords[i]);
                    shipmentCollection.add(placemark);
                    console.log('Placemark', totalCoords[i]);
                }
                shipmentMap.geoObjects.add(shipmentCollection); 
                var bounds = shipmentCollection.getBounds();
                console.log('Bounds', bounds);
                shipmentMap.setBounds(bounds, { checkZoomRange: true });
                //shipmentMap.setZoom(shipmentMap.getZoom());
            })
        }
    }

    proj.Shipment = function(){
        initShipment();
    };

    return proj;
})(Proj || {});



